import script from "./NotSubmittedText.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotSubmittedText.vue?vue&type=script&setup=true&lang=ts"

import "./NotSubmittedText.vue?vue&type=style&index=0&id=b22fd26a&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b22fd26a"]])

export default __exports__